import React, { useEffect, useState } from 'react';
import './TempComponent.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTemperatureFull } from '@fortawesome/free-solid-svg-icons';

const config = require('../config');

const TempComponent = ({ index, curDate, smedsbyHeatingValues, villaHeatingValues }) => {
  const smedsbyHeatingTemperature = smedsbyHeatingValues?.smedsbyTemperature ? smedsbyHeatingValues.smedsbyTemperature : "";
  const smedsbyHeatingOn = smedsbyHeatingValues ? smedsbyHeatingValues.smedsbyHeatingOn : true;
  const villaHeatingTemperature = villaHeatingValues?.villaTemperature ? villaHeatingValues.villaTemperature : "";  
  const [smedsbyTemperature, setSmedsbyTemperature] = useState(smedsbyHeatingTemperature);
  const [isSmedsbyHeatingOn, setIsSmedsbyHeatingOn] = useState(smedsbyHeatingOn);
  const [villaTemperature, setVillaTemperature] = useState(villaHeatingTemperature);

  const token = localStorage.getItem('token');

  const handleSmedsbyTemperatureChange = (event) => {
    setSmedsbyTemperature(event.target.value);
    if ((event.target.value >= 15 && event.target.value <= 25) || event.target.value === "") {
      postSmedsbyValues(event.target.value, isSmedsbyHeatingOn);
    }
  };

  const handleVillaTemperatureChange = (event) => {
    setVillaTemperature(event.target.value);
    if ((event.target.value >= 5 && event.target.value <= 30) || event.target.value === "") {
       postVillaValues(event.target.value);
     }
  };

  useEffect(() => {
    const smedsbyHeatingTemperature = smedsbyHeatingValues?.smedsbyTemperature ? smedsbyHeatingValues.smedsbyTemperature : "";
    const smedsbyHeatingOn = smedsbyHeatingValues ? smedsbyHeatingValues.smedsbyHeatingOn : true;
    setSmedsbyTemperature(smedsbyHeatingTemperature);
    setIsSmedsbyHeatingOn(smedsbyHeatingOn);
  }, [smedsbyHeatingValues, curDate]);

  useEffect(() => {
    const villaHeatingTemperature = villaHeatingValues?.villaTemperature ? villaHeatingValues.villaTemperature : "";      
    setVillaTemperature(villaHeatingTemperature);
  }, [villaHeatingValues, curDate]);

  const toggleHeatPump = () => {
    const newValue = !isSmedsbyHeatingOn;
    
    if (!newValue)
      setSmedsbyTemperature("");

    setIsSmedsbyHeatingOn(newValue);
    postSmedsbyValues(smedsbyTemperature, newValue);
  };

  const postSmedsbyValues = (newSmedsbyTemperature, newIsSmesbyHeatingOn) => {
    if (newSmedsbyTemperature < 15 || newSmedsbyTemperature > 25)
      newSmedsbyTemperature = "";

    fetch(config.serverUrl + '/heating-target', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "env": "smedsby",
        "time": moment(curDate).format('YYYY-MM-DD') + " " + String(index).padStart(2, '0') + ":00:00",
        "smedsbyHeatingTemperature": newSmedsbyTemperature,
        "smedsbyHeatingOn": newIsSmesbyHeatingOn ? "1" : "0"
      })
    })
    .catch(error => { console.log(error); });    
  }

  const postVillaValues = (newVillaTemperature) => {
    if (newVillaTemperature < 5 || newVillaTemperature > 30)
      newVillaTemperature = "";

    fetch(config.serverUrl + '/heating-target', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "env": "villa",
        "time": moment(curDate).format('YYYY-MM-DD') + " " + String(index).padStart(2, '0') + ":00:00",
        "villaHeatingTemperature": newVillaTemperature
      })
    })
    .catch(error => { console.log(error); });    
  }

  //const hourLabel = String(index).padStart(2, '0') + '-' + String((index + 1)).padStart(2, '0')
  const hourLabel = String(index).padStart(2, '0');

  return (
    <div>
      <div className="hour-label-div">
        <label htmlFor={`temperature-input-${index}`} className="hour-label">{hourLabel}</label>
      </div>
      <div>        
        <input
          className="temperature-input"
          type="text" 
          value={smedsbyTemperature} 
          onChange={handleSmedsbyTemperatureChange} 
          placeholder="smedsby"
        />
      </div>
      <div>        
        <input
          className="temperature-input"
          type="text" 
          value={villaTemperature} 
          onChange={handleVillaTemperatureChange} 
          placeholder="villa"
        />
      </div>
      <div>
        <div onClick={toggleHeatPump}>
          <FontAwesomeIcon icon={faTemperatureFull} color={isSmedsbyHeatingOn ? 'green' : 'red'} size="xs"/>
        </div>
      </div>
    </div>
  );
};

export default TempComponent;